// Auth-hint (perf 2026-08-11).
//
// De sessie-cookie is HttpOnly — JS kan niet zien of je ingelogd bent en moet
// daarvoor /api/auth/status afwachten (0,3-2,8 s gemeten op de Pi). Zolang dat
// antwoord uitbleef, startte er geen enkele datafetch en bleef het scherm wit.
//
// Deze hint is puur een LOKALE herinnering ("de vorige keer was je ingelogd,
// en toen als beheerder"). Hij zegt niets over de geldigheid van de sessie en
// is dus GEEN auth-mechanisme: de server blijft elke request zelf beoordelen.
// Hij wordt alleen gebruikt om de fetches al te starten terwijl
// /api/auth/status onderweg is. Klopt de hint niet meer, dan geven die
// requests 401, wordt de hint gewist en verschijnt gewoon het loginscherm.

const KEY = 'zbs.auth.hint';

export interface AuthHint {
  /** Had de gebruiker bij zijn laatste bekende sessie de beheerdersrol? */
  admin: boolean;
}

export function readAuthHint(): AuthHint | null {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { admin?: unknown };
    return { admin: parsed?.admin === true };
  } catch {
    // Private mode, quota, of corrupte waarde — dan gewoon geen hint.
    return null;
  }
}

export function writeAuthHint(admin: boolean): void {
  try {
    window.localStorage.setItem(KEY, JSON.stringify({ admin }));
  } catch {
    /* geen hint is niet erg — alleen langzamer */
  }
}

export function clearAuthHint(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* idem */
  }
}
